module.exports = __webpack_public_path__ + "img/demo_woman2.be7b49f2.svg";